var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGymoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 370.097,
    height: 258.386,
    viewBox: "0 0 370.097 258.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647",
    transform: "translate(-455.008 -383.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1581",
    "data-name": "Rectangle 1581",
    width: 43.948,
    height: 316.199,
    rx: 21.974,
    transform: "translate(678.595 386.891) rotate(45)",
    fill: "#30d598"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1583",
    "data-name": "Rectangle 1583",
    width: 43.948,
    height: 146.554,
    rx: 21.974,
    transform: "translate(667.555 506.849) rotate(45)",
    fill: "#30d598"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1582",
    "data-name": "Rectangle 1582",
    width: 43.948,
    height: 148.044,
    rx: 21.974,
    transform: "translate(571.573 383.167) rotate(45)",
    fill: "#30d598"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1584",
    "data-name": "Rectangle 1584",
    width: 43.948,
    height: 148.044,
    rx: 21.974,
    transform: "translate(794.03 383.167) rotate(45)",
    fill: "#30d598"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymoLogo);
export default __webpack_public_path__ + "static/media/gymo_logo.70eff1cfe82fafda1ceea23ecb78bbb8.svg";
export { ForwardRef as ReactComponent };